import { XML_AddLinkToPPT } from "./XML_AddLinkToPPT";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { RoundTo3 } from "./RoundTo3";
import { XML_Cmd4 } from "./XML_Cmd4";
import { XML_Param4 } from "./XML_Param4";

export function XML_DrawLargeSubchartArrowPPT(
  x0,
  x1,
  x2,
  x3,
  x4,
  y0,
  y1,
  y2,
  fillColor,
  drawElement,
  linkBookmark,
  layer
) {
  if (!drawElement.fIncludeSCArrows || linkBookmark == null) return;

  x0 = XML_ScaleAndShiftX(x0, drawElement, layer);
  x3 = XML_ScaleAndShiftX(x3, drawElement, layer);

  y0 = XML_ScaleAndShiftY(y0, drawElement, layer);
  y2 = XML_ScaleAndShiftY(y2, drawElement, layer);

  y0 = drawElement.ConvertY(y0);
  y2 = drawElement.ConvertY(y2);

  var shapeString = "";
  if (y2 > y0) shapeString = "dna";
  else shapeString = "upa";

  XML_Cmd4(
    shapeString,
    RoundTo3(x0),
    RoundTo3(y0),
    RoundTo3(x3 - x0),
    RoundTo3(y2 - y0),
    drawElement
  );
  XML_Param4("p", fillColor, "#000000", 1, 0, drawElement);
  XML_AddLinkToPPT(linkBookmark, drawElement);
}
